export const PDF_DOCUMENT_DEFAULT_WIDTH = 533;
export const PDF_DOCUMENT_DEFAULT_HEIGHT = 879;
export const FOOTER_HEIGHT = 66;
